<template>
  <popup-layout title="카테고리 추가" width="400" :is-show="isShow">
    <template v-slot:content>
      <field-input title="카테고리명">
        <v-text-field
          v-model="categoryNm"
          placeholder="입력"
          outlined hide-details dense
          background-color="white"
        />
      </field-input>
      <field-input title="카테고리 권한">
        <v-select
          v-model="useRole"
          :items="useRoleList"
          item-text="text"
          item-value="value"
          placeholder="선택"
          outlined hide-details dense
          background-color="white"
        />
      </field-input>
    </template>
    <template v-slot:button>
      <div class="buttons-layout">
        <v-btn class="button save" outlined @click="save">저장</v-btn>
        <v-btn class="button delete" outlined @click="closePopup">취소</v-btn>
      </div>
    </template>
  </popup-layout>
</template>

<script>
import PopupLayout from "@/common/layout/PopupLayout.vue";
import FieldInput from "@/common/components/input/FieldInput.vue";
import {axiosInstance} from "@/util/AxiosModule";

export default {
  name: "CategoryAdd",
  components: {FieldInput, PopupLayout},
  props: ["isShow", "useRoleList"],
  data() {
    return {
      categoryNm: "",
      useRole: ""
    }
  },
  methods: {
    async save() {
      if (confirm("입력한 카테고리를 생성하시겠습니까?")) {
        await axiosInstance.post("/admin/board/category", {}, {
          params: {
            categoryNm: this.categoryNm,
            useRole: this.useRole
          }
        }).then(() => {
          this.showAlert({
            message: "생성이 완료되었습니다.",
            successCallback: () => {
              this.setDefaultData();
              this.closePopup();
              this.$emit("refresh");
            }
          })
        })
      }
    },
    setDefaultData() {
      this.categoryNm = "";
      this.useRole = "";
    },
    closePopup() {
      this.$emit("close");
    }
  }
}
</script>

<style lang="scss" scoped>
.buttons-layout {
  width: 100%;
  padding: 10px 0;
  display: flex;
  justify-content: center;
}
</style>